import { Home } from "./Home";
import { Landing } from "./Landing";

import { AuthPage } from "../Modules/Auth/components/AuthPage";
import { ChangePassword } from "../Modules/Auth/components/ChangePassword";
import { ForgotPassword } from "../Modules/Auth/components/ForgotPassword";
import { Register } from "../Modules/Auth/components/Register";
import { ResetPassword } from "../Modules/Auth/components/ResetPassword";
import { Login } from "../Modules/Auth/components/Login";

import { UsersPage } from "../Modules/Users/components/UsersPage";
import { Users } from "../Modules/Users/components/Users";

import { VehiclesPage } from "../Modules/Vehicle/components/VehiclesPage";
import { Vehicles } from "../Modules/Vehicle/components/Vehicles";
import { Drivers } from "../Modules/Vehicle/components/Drivers";
import { Vehicle } from "../Modules/Vehicle/components/Vehicle";

import { NotFound } from "../Shared/components/404";
import { About } from "../Shared/components/About";
import { Sidebar } from "../Shared/components/Sidebar";

import { Companies } from "../Modules/Users/components/Companies";
import { SettingsPage } from "../Modules/Settings/components/SettingsPage";
import { Activities } from "../Modules/Settings/components/Activities";
import { Settings } from "../Modules/Settings/components/Settings";
import { Dashboard } from "../Modules/Dashboard/components/Dashboard";
import { Company } from "../Modules/Users/components/Company";
import { ApprovalForm } from "../Modules/Users/components/ApprovalPreview/ApprovalForm";
import { PostPage } from "../Modules/Post/Components/PostPage";
import { PostDetail } from "../Modules/Post/Components/PostDetail";
import { Driver } from "../Modules/Vehicle/components/Driver";
import { Approvals } from "../Modules/Users/components/Approvals";
import { Approval } from "../Modules/Users/components/Approval";
import { Activity } from "../Modules/Settings/components/Activity";
import { TermsAndConditions } from "./TermsAndConditions";

export const AppRoutes = [
  {
    path: "",
    element: <Home />,
    children: [
      { path: "", element: <Landing /> },
      { path: "terms-and-conditions", element: <TermsAndConditions /> },
      {
        path: "/auth",
        element: <AuthPage />,
        children: [
          { path: "login", element: <Login /> },
          { path: "register", element: <Register /> },
          { path: "forgot-password", element: <ForgotPassword /> },
          { path: "reset-password", element: <ResetPassword /> },
          { path: "change-password", element: <ChangePassword /> },
        ],
      },
      {
        path: "services",
        element: <Sidebar />,
        children: [
          {
            path: "accounts",
            element: <UsersPage />,
            children: [
              { path: "home", element: <Dashboard /> },
              { path: "users", element: <Users /> },
              { path: "companies", element: <Companies /> },
              { path: "companies/details", element: <Company /> },
              { path: "approval", element: <ApprovalForm /> },
              { path: "approvals", element: <Approvals /> },
              { path: "approvals/details", element: <Approval /> },
              { path: "posts", element: <PostPage /> },
              { path: "posts/details", element: <PostDetail /> },
            ],
          },
          {
            path: "vehicles",
            element: <VehiclesPage />,
            children: [
              { path: "home", element: <Vehicles /> },
              { path: "details", element: <Vehicle /> },
              { path: "drivers", element: <Drivers /> },
              { path: "drivers/details", element: <Driver /> },
            ],
          },
          {
            path: "settings",
            element: <SettingsPage />,
            children: [
              { path: "home", element: <Activities /> },
              { path: "home/activity", element: <Activity /> },
              { path: "account", element: <Settings /> },
            ],
          },
        ],
      },
      { path: "approval/form", element: <ApprovalForm /> },
      { path: "posts/details", element: <PostDetail /> },
      { path: "posts/company", element: <PostPage /> },
      { path: "home", element: <Landing /> },
      { path: "about", element: <About /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];
